// Teklif PDF'inin 2. sayfası — kış sezonu rezervasyon, ödeme ve iptal koşulları.
//
// Kaynak: "İPTAL POLİTİKASI3.docx" (2026-09-19 güncellemesi). Hukuki metindir: cümleler Word'deki hâliyle aktarıldı,
// yalnızca satır kırılması/boşluk hataları düzeltildi. Word'deki "Ödeme planı:" / "İptal koşulları:" etiketleri
// PDF'te bölüm başlığı olarak basılır (headings). Metin değişince YALNIZCA bu dosyayı
// güncelleyin; OfferPDF.js düzeni ve 1. sayfadaki yönlendirme buradan okur.
//
// Tüm teklif PDF'lerinde SON sayfa olarak basılır (bkz. OfferPDF.js → CancellationPolicyPage).
// Genellikle 2. sayfadır; çok odalı tekliflerde 1. sayfa taşarsa 3. sayfa olur.

export const CANCELLATION_POLICY = {
  title: 'KIŞ SEZONU REZERVASYON VE İPTAL KOŞULLARI',
  // PDF başlığında iki satır (1. sayfadaki "ÖN REZERVASYON FİYAT VE / DETAY BİLGİ FORMU" gibi)
  titleLines: ['KIŞ SEZONU REZERVASYON VE', 'İPTAL KOŞULLARI'],

  // Hazır BÜYÜK harfle yazılı: react-pdf'in textTransform: 'uppercase'ı Türkçe bilmez ("Kesinti" → "KESINTI").
  headings: {
    paymentPlan: 'ÖDEME PLANI',
    deductionTable: 'İPTAL KESİNTİ TABLOSU',
    conditions: 'İPTAL KOŞULLARI',
    legalNotice: 'YASAL BİLGİLENDİRME',
  },

  // Ödeme Planı bölümünde sırayla basılan paragraflar
  paymentPlan: {
    paragraphs: [
      "Konaklama rezervasyonlarında, toplam konaklama bedelinin %50'si rezervasyonun kesinleştirilmesi aşamasında ön ödeme olarak tahsil edilir. Kalan %50'lik bakiye, konaklama başlangıç tarihinden en geç 30 (otuz) gün önce misafir tarafından eksiksiz olarak ödenmek zorundadır.",
      'Kalan bakiyenin belirtilen süre içerisinde ödenmemesi halinde, Otel, rezervasyonu tek taraflı olarak iptal etme ve tahsil edilmiş olan %50 oranındaki ön ödeme bedelini, herhangi bir iade yükümlülüğü bulunmaksızın uhdesinde tutma hakkına sahiptir. Misafir, rezervasyonu onayladığı ve/veya ön ödeme yaptığı anda işbu ödeme koşullarını ve bunların sonuçlarını kabul etmiş sayılır.',
    ],
  },

  deductionTable: {
    columns: ['İptal zamanı', 'Kesinti'],
    // PDF yalnızca when + deduction basar. rate (0–100, null = orana bağlı değil) eski tasarımdan kalma, basılmaz.
    rows: [
      { when: 'Girişten 45 gün veya daha önce', deduction: 'Ücretsiz', rate: 0 },
      { when: '44–30 gün kala', deduction: '%30', rate: 30 },
      { when: '29–21 gün kala', deduction: '%50', rate: 50 },
      { when: '20–15 gün kala', deduction: '%75', rate: 75 },
      { when: '14 gün ve daha az', deduction: '%100', rate: 100 },
      { when: 'Erken çıkış', deduction: 'Kullanılmayan geceler %100', rate: 100 },
      { when: 'Tarih değişikliği', deduction: 'İptal hükmüne tabi', rate: null },
    ],
  },

  conditions: [
    'Giriş tarihinden 45 gün veya daha önce yapılan iptallerde herhangi bir ücret alınmaz.',
    "Giriş tarihine 44–30 gün kala yapılan iptallerde toplam rezervasyon bedelinin %30'u tahsil edilir.",
    "Giriş tarihine 29–21 gün kala yapılan iptallerde toplam rezervasyon bedelinin %50'si tahsil edilir.",
    "Giriş tarihine 20–15 gün kala yapılan iptallerde toplam rezervasyon bedelinin %75'i tahsil edilir.",
    "Giriş tarihine 14 gün veya daha az süre kala yapılan iptallerde toplam rezervasyon bedelinin %100'ü tahsil edilir.",
    "Konuğun otele gelmemesi (No-Show) durumunda toplam rezervasyon bedelinin %100'ü tahsil edilir.",
    'Erken çıkış veya konaklama süresinin kısaltılması durumunda kullanılmayan geceler için ücret iadesi yapılmaz.',
    'Rezervasyon tarih değişiklikleri, müsaitlik ve güncel fiyat koşullarına bağlıdır ve iptal koşullarına tabi olabilir.',
    'İptal taleplerinin yazılı olarak iletilmesi gerekmektedir. İptal tarihi, otel tarafından talebin yazılı olarak alındığı tarih esas alınarak belirlenir.',
    'Yılbaşı, sömestr ve otel tarafından belirlenen özel dönemlerde farklı ve daha sıkı iptal koşulları uygulanabilir; bu koşullar rezervasyon sırasında misafire bildirilir.',
  ],

  legalNotice: [
    'Kayak merkezindeki hava koşulları, kar kalınlığı, pistlerin veya liftlerin geçici olarak kapatılması gibi durumlar ile ayrıca hava koşullarının tüketicinin kişisel tercihi, beklentisi veya memnuniyetsizliği nedeniyle uygun bulunmaması tek başına ücretsiz fesih hakkı doğurmaz.',
    'Tüketicinin hastalık veya kişisel sağlık gerekçesiyle tura katılamaması yine aynı şekilde tek başına ücretsiz fesih hakkı doğurmaz.',
    'Tüketici, konaklama başlangıcından önce sözleşmeden doğan yükümlülüklerini yerine getirebilecek durumda olan üçüncü bir kişiye devredebilir. Devir işleminin mevzuatta öngörülen şartları ve süreleri kapsamında yapılması halinde, devirden kaynaklanan ve belgelendirilebilen makul ek maliyetler ayrıca talep edilebilir.',
    'Fesih sonucunda tüketiciye iade edilmesi gereken tutarlar, yürürlükteki mevzuatta öngörülen süre içerisinde ve ödemenin gerçekleştirildiği yönteme uygun olarak iade edilir. Kredi kartı ile yapılan ödemelerde, bankacılık sisteminden kaynaklanan taksitli işlem, provizyon ve benzeri hususlar bakımından bankanın uyguladığı işlem süreleri ayrıca dikkate alınabilir.',
    'Misafir, rezervasyon işlemini tamamlayarak, rezervasyon sırasında kendisine sunulan İptal ve İade Koşulları’nı tamamen okuduğunu, anladığını ve herhangi bir itirazı olmaksızın kabul ettiğini beyan ve taahhüt eder. Rezervasyonun iptali, değiştirilmesi veya kullanılmaması durumunda, rezervasyon tarihinde geçerli olan İptal ve İade Koşulları esas alınır.',
    'Mücbir sebep veya ilgili mevzuattan doğan zorunlu haller saklıdır.',
  ],

  // 1. sayfadaki "İptal ve İade Koşulları" kutusunda basılan yönlendirme.
  // Sayfa NUMARASI verilmez: çok odalı tekliflerde 1. sayfa taşıp 2 sayfa olabilir; koşullar her zaman
  // SON sayfadadır. (react-pdf `render` prop'u akıştaki, fixed olmayan Text'te boş basılıyor.)
  page1Reference: 'Rezervasyon, ödeme ve iptal koşulları son sayfada yer almaktadır.',
};
